import { useEffect, useState } from "react";
import api from "@/lib/api";

// One shared request for every pixel badge on screen; null when the user can't see pixels.
const TTL = 30000;
let cache = null;
const subs = new Set();

export function loadPixelBadges(force = false) {
  if (force || !cache || Date.now() - cache.at > TTL) {
    const promise = api.get("/admin/pixel-check/badges").then((r) => r.data).catch(() => null);
    cache = { at: Date.now(), promise };
    promise.then((d) => subs.forEach((fn) => fn(d)));
  }
  return cache.promise;
}

export function usePixelBadges() {
  const [d, setD] = useState(null);
  useEffect(() => {
    subs.add(setD);
    loadPixelBadges().then(setD);
    return () => { subs.delete(setD); };
  }, []);
  return d;
}
